import { init as initSentry, Integrations } from '@sentry/browser'
import '@babel/polyfill'
import App from './App.vue'
import i18n from './i18n'
import Multiselect from 'vue-multiselect'
import store from '@/store'
import VeeValidate from 'vee-validate'
import VModal from 'vue-js-modal'
import Vue from 'vue'
import VueProgressBar from 'vue-progressbar'
import { device } from 'civ2-js-utils'
import { getUrlParams } from '@/utils/url'
import { router } from '@/router'
import { sync } from 'vuex-router-sync'
import IntlPolyfill from 'intl'

import 'intl/locale-data/jsonp/en'
import 'intl/locale-data/jsonp/de'
import 'intl/locale-data/jsonp/fr'
import 'intl/locale-data/jsonp/it'
import 'intl/locale-data/jsonp/es'
import 'intl/locale-data/jsonp/nl'

sync(store, router)

Vue.config.productionTip = false
Vue.component('multiselect', Multiselect)
Vue.use(VeeValidate)
Vue.use(VModal, { dynamic: true, injectModalsContainer: true })

Vue.use(VueProgressBar, {
  color: '#54C100',
  failedColor: '#F85359',
  thickness: '2px',
})

console.log(
  `%c CI Booking %c ${process.env.git.COMMITHASH} %c ${process.env.git.BRANCH} %c`,
  'background:#35495e; padding: 1px; border-radius: 3px 0 0 3px; color: #fff',
  'background:#54c100; padding: 1px; color: #fff',
  'background: #f5a623; padding: 1px; border-radius: 0 3px 3px 0; color: #fff',
  'background:transparent'
)

if (!window['Ixntl']) {
  window.Intl = IntlPolyfill
}

if (process.env.VUE_APP_SENTRY_DSN) {
  console.debug('activating sentry')
  initSentry({
    dsn: process.env.VUE_APP_SENTRY_DSN,
    environment: `${process.env.VUE_APP_ENVNAME}`,
    integrations: [new Integrations.Vue({ Vue })],
  })
}

Vue.filter('currency', function(value, currency, lang) {
  return new Intl.NumberFormat(lang, {
    style: 'currency',
    currency: currency,
  }).format(value)
})

// detect touch device
if (device.hasTouch()) {
  const root = document.getElementsByTagName('html')[0]
  if (root.classList.contains('no-touch')) {
    root.classList.remove('no-touch')
  }
}

export default new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
  beforeMount: () => {
    const { lang, campground } = getUrlParams()
    // set discount value from query param
    let discount = new URLSearchParams(window.location.search).get('discount')
    discount = discount && discount.replace(/\/.*/, '') // remove chars after %2F i.e. / after discount value
    if (discount) {
      store.dispatch('application/setDiscountValue', discount)
    }
    store.dispatch('application/setLanguageSlug', lang)
    store.dispatch('application/setCampground', campground)
  },
}).$mount('#app')
